module.exports = __webpack_public_path__ + "public/img/联动配置bg.804e4664.png";